const headache = [

    {label:"Side(s)",
    controlType:"checkbox group",
    options:["Central", "Right", "Left"]
    },


    {label:"Site(s)",
    controlType:"checkbox group",
    options:["Sinus", "Frontal", "Lateral", "Posterior"]
    },


    {label:"Severity",
    controlType:"radio button",
    options:["Mild", "Moderately severe", "Severe"]   
    },


    {label:"Headache features",
    controlType:"checkbox group",
    options:["aura", "nausea","vomiting", "motion sensitivity","posture related pain",  "photophobia", "pulse-synchronous tinnitus", "phonophobia", "papilloedema"]
    },

    {label:"Other features",
    controlType:"text area",
    options:[]
    },

    {label:"When present",
    controlType:"radio button",
    options:["Constant","Intermittent"]
    },

    {label:"Frequency",
    controlType:"radio button",
    options:["Every day", "Most days", "Evey week or two", "Occasionally"]
    },

    {label:"Present for several:",
    controlType:"radio button",
    options:["Days", "Weeks","Months","Years"]
    }
    
    ]
    
    export default headache



